import { error, info, warn } from "./log.js";
export { assertIsNotNullish } from "@jaybeeuu/is";
export { asError } from "./as-error.js";
export { debounce } from "./debounce.js";
export { delay, echo, microEcho, } from "./delay.js";
export { joinUrlPath } from "./join-url-path.js";
export const log = {
    error,
    info,
    warn,
};
export { getErrorMessage } from "./log.js";
export { multiPartition } from "./multi-partition.js";
export * from "./promise-status.js";
export * from "./results.js";
export * from "./title-case.js";
//# sourceMappingURL=index.js.map